import React, { useState, useEffect, useContext } from 'react';
import Modal from '../../../UI/Modal/Modal'

import Client from "../../../../assets/Icon/User"; 
import tbl from '../../../../assets/Style/Table.module.css' 
import fnc from '../Finances.module.css'
import paycl from './TransactionModal.module.css'
import { useTransaction } from '../../../../hooks/useTransactions';
import Remove from "../../../../assets/Icon/Remove";
import { useUpdateEffect } from '../../../../hooks/useUpdateEffect';
import { AppContext } from '../../../../providers/appProvider';
import { baseFileURL } from '../../../../Api';
import Select from "react-select"; 
import { selectStyle } from './selectStyle';
import DateSelect from '../../../UI/Inputs/DateSelect';

const TransactionModal = ({ car, setCar, typeId, paid, carService }) => {
    
    const { appState, app } = useContext(AppContext);
 
    const [inputValues, setInputValues] = useState({}); 

    const [carsOptions, setCarsOptions] = useState({}); 
    const [selectedOption, setSelectedOption] = useState(1);

    const [newTransaction, setNewTransaction] = useState({
        amount: 0,
        description: "",
        car_id: car.id,
        status_id: selectedOption,
        type_id: typeId,
        is_deposit: true,
        car_vin: '',
        created_at: new Date().toISOString(),
    })


    const [transferTransaction, setTransferTransaction] = useState({
        amount: 0,
        description: "",
        car_id: 0,
        status_id: 3,
        type_id: typeId,
        car_vin: '',
        created_at: new Date().toISOString(),
    })


    const statusOptions = [
      { value: 1, label: "ჩარიცხვა" },
      { value: 2, label: "უკან დაბრუნება" }, 
    ];
     
    const selectedOptionObject = statusOptions.find(option => option.value === selectedOption);

    const formatDate = (dateString) => {

        const purchasedAtDate = new Date(dateString);

        const months = [
            "იან",
            "თებ",
            "მარ",
            "აპრ",
            "მაი",
            "ივნ",
            "ივლ",
            "აგვ",
            "სექ",
            "ოქტ",
            "ნოე",
            "დეკ"
        ];

        const day = purchasedAtDate.getDate();
        const month = months[purchasedAtDate.getMonth()];
        const year = purchasedAtDate.getFullYear();

        return `${day} ${month}  ${year}`;
    };

    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [isDealer, setIsDealer] = useState(false);

    useEffect(() => {
        if (isDealer) {
            setNewTransaction({
                ...newTransaction,
                dealer_id: car.dealer.id
            });
        } else {
            setNewTransaction({
                ...newTransaction,
                dealer_id: 0
            });
        }
 
    }, [isDealer]);


    const [file, setFile] = useState("null");
    const [isModalOpen, setIsModalOpen] = useState(false);
    var price = 0

    const { transactionService } = useTransaction(car.id);
    const { transactionTransferService } = useTransaction(transferTransaction.car_id);
 
    const [validates, setValidates] = useState({})

    const validateTransaction = (transaction) => {
        const messages = {};

        
        if ( transaction.amount < 1) {
            messages.amount = { message: 'მიუთითეთ თანხა', isValid: false };
        }

        if ( transaction.status_id == 3 && transaction.car_vin.length < 2) {
            messages.vin = { message: 'აირჩიეთ ავტომობილი', isValid: false };
        }

        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };

    var isDeletePerm = false
    var isAddPerm = false
 
    if (typeId === 1) {

        if (app.hasPermission("CLIENT_PAID_DELETE")) {
            isDeletePerm = true 
        }

        if (app.hasPermission("CLIENT_PAID_ADD")) {
            isAddPerm = true 
        }

        price = car.client_price_car +
            car.client_price_transport +
            car.client_price_internal +
            car.client_price_dealer +
            car.client_price_dealer_transport +
            car.client_price_document +
            car.client_price_insurance +
            car.client_price_penalty +
            car.client_price_deposit +
            car.client_price_transfer_fee +
            car.client_price_another;
    } else {

        if (app.hasPermission("COMPANY_PAID_DELETE")) {
            isDeletePerm = true 
        }

        if (app.hasPermission("COMPANY_PAID_ADD")) {
            isAddPerm = true 
        }
        price = car.car_price_car +
            car.car_price_transport +
            car.car_price_internal +
            car.car_price_dealer +
            car.car_price_dealer_transport +
            car.car_price_document +
            car.car_price_insurance +
            car.car_price_penalty +
            car.car_price_deposit +
            car.car_price_transfer_fee +
            car.car_price_another;
    }

    const [transactions, setTransactions] = useState([])
 
    var transactionsFiltered = transactions.filter((transaction) => transaction.type_id === typeId &&  transaction.is_deposit === true );

    const sumOfAmount = transactionsFiltered.reduce((acc, item) => acc + item.amount , 0);

    useEffect(() => {

        setSelectedOption(1)

        if (car && car.transactions) {
             setTransactions(car.transactions)
        }

    }, [car]);


    useEffect(() => {
        setSelectedOption(1)
    }, []);

 
    useUpdateEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateTransaction(newTransaction)
        }
    }, [newTransaction]);

 

    function convertToInt(str) {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
    }
  
    const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const regex = /^[0-9]+$/;

        if (!regex.test(keyValue)) {
            event.preventDefault();
        }
    };

    const handleFocus = (e) => {
        if (e.target.value === '0') {
            setNewTransaction({
                ...newTransaction,
                amount: ""
            });
            setTransferTransaction({
                ...transferTransaction,
                amount: ""
            });
        }
    };

    const handleBlur = (e) => {
        if (e.target.value === '') {
            let val = convertToInt(0);
            setNewTransaction({
                ...newTransaction,
                amount: val
            });
            setTransferTransaction({
                ...transferTransaction,
                amount: val
            });
        };
    };

 
 
    const openModal = () => {
        setValidates({})
        
        setSelectedOption(1)

        setNewTransaction({
            ...newTransaction,
            amount: 0,
            description: "",
            car_id: car.id,
            status_id: 1,
            car_vin: "",
            type_id: typeId,
            created_at: new Date().toISOString(),
        });

        setTransferTransaction({
            ...newTransaction,
            amount: 0,
            description: "",
            car_id: "",
            status_id: 3,
            car_vin: "",
            type_id: typeId,
            created_at: new Date().toISOString(),
        });
 
 
        setIsModalOpen(true)
        setIsDealer(false) 

    }

     
    const handleDateChange = (date) => {

        setNewTransaction(prevState => ({
            ...prevState,
            created_at: date ? date : "",
        }));
        
        setTransferTransaction(prevState => ({
            ...prevState,
            created_at: date ? date : "",
        })); 

        
    };
     
    const handleChangeStatus = (option) => {
  
        setSelectedOption(option.value); 

        if (option.value == 3) {

            setInputValues({});

            setNewTransaction(prevState => ({
                ...prevState,
                status_id: option.value
            }));  
   
            setTransferTransaction(prevState => ({
                ...prevState, 
                status_id: option.value
            }));   
 
            const carsOptions = carService.cars.map((carReciver) => ({ value: carReciver.id, label: carReciver.vin  })); 
            setCarsOptions(carsOptions);  
            
        } else {

            setNewTransaction(prevState => ({
                ...prevState,
                status_id: option.value ,
                car_vin: ''
            }));   
 
            setTransferTransaction({  });

            setCarsOptions(''); 
            setInputValues({});

        }

 
    
    };
    
    const handleChangeVin = (selectedOption, id) => {

        if (selectedOption) {
 
            setNewTransaction(prevState => ({
                ...prevState,  
                car_vin: selectedOption.label,         
            }));  

            setTransferTransaction(prevState => ({
                ...prevState, 
                car_id: selectedOption.value, 
                car_vin: car.vin ,         
            })); 
 
            setInputValues({ ...inputValues, [id]: selectedOption.value });
            
        } else {

            setNewTransaction(prevState => ({
                ...prevState,  
                car_vin: '' ,         
            }));  
 

            setInputValues({ ...inputValues, [id]: '' });
        }

    };
 
    const handleChangeAmount = (event) => {
        var val = ""

        if (event.target.name === "amount") {
            val = convertToInt(event.target.value);
        } else {
            val = event.target.value
        }
 
        setNewTransaction(prevState => ({
            ...prevState,  
            amount: val,         
        }));  


        setTransferTransaction(prevState => ({
            ...prevState, 
            amount: val,          
        }));   

 
    };


    const onAdd = () => {

        const isValidate = validateTransaction(newTransaction)

        const newForm = new FormData();
        
        let updatedTransaction = {
            ...newTransaction, 
            amount: selectedOption === 2 || selectedOption === 3 ? -Math.abs(newTransaction.amount) : newTransaction.amount,
        };
         
        for (let key in updatedTransaction) {
            newForm.append(key, updatedTransaction[key]);
        } 
    
        newForm.append('doc', file);

        // Transfer transaction
        const newFormTransfer = new FormData();

        if(selectedOption === 3 ) {
  
         
            let updatedTransferTransaction = {
                ...transferTransaction,
                amount: transferTransaction.amount,
            };
    
            for (let key in updatedTransferTransaction) {
                newFormTransfer.append(key, updatedTransferTransaction[key]);
            } 
    
            newFormTransfer.append('doc', file);


        }
       
        // Transfer transaction  

        if (isValidate === true) {

            transactionService.addTransaction(newForm)
                .then(response => {
                    carService.fetchCars()
                })
                .catch(error => {
                    console.error(error);
                });
 


            if(selectedOption === 3 ) {

                transactionTransferService.addTransaction(newFormTransfer)

            }

            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true)
        } 
    }

    const onRemove = (transactionId) => {
        transactionService.removeTransaction(transactionId)
            .then(response => {
                 carService.fetchCars()
            })
            .catch(error => {
                console.error(error);
            });
    }


    let doneclass = ' '

    if (typeId == 1) {
        if (car.total_client_paid >= car.total_client_price) {
            doneclass = fnc.greenFin
        }
    } else {
        if (car.total_company_paid >= car.total_company_price) {
            doneclass = fnc.greenFin
        }
    }
 
 
 

 
    

    return (
        <div>

            <div onClick={() => { 
                    if (car.website && (car.website.id == 5)){
                        openModal()
                    }  
                    
                    }} className={fnc.financeBox  }  >
                    <div className={fnc.financeValue}>
                    {(sumOfAmount !== 0 ? sumOfAmount : ' ')} 
                </div> 
            </div>

            <Modal isOpen={isModalOpen} size="medium" onClose={() => setIsModalOpen(false)}>

                <div className={paycl.modalHead} >
                    <h3>
                        <span className={fnc.iconHead} > <Client /> </span>
                        კლიენტის დეპოზიტი
                    </h3>
                </div>


                <div>
                    <div className={tbl.table + ' ' + paycl.table} style={{ minHeight: '50px' }}>

                        <table>
                            <thead>
                                <tr>
                                    <th className={paycl.id}>#</th> 
                                    <th>ფაილი</th>
                                    <th>თარიღი</th>
                                    <th>თანხა</th> 
                                    <th>სტატუსი</th>
                                    <th className={paycl.btntbl}> </th>
                                </tr>
                            </thead>
                            <tbody>

                                {transactionsFiltered.map((transaction, index) =>
                                    <tr key={ index }>
                                        <td className={paycl.id}>{index + 1}</td> 
                                        <td>
                                            {
                                                transaction.doc === 'null' || transaction.doc &&
                                                <a href={baseFileURL + transaction.doc} target='_blank' rel="noopener noreferrer">
                                                    ფაილი
                                                </a>
                                            }
                                        </td>
                                        <td> {formatDate(transaction.created_at)} </td>
                                        <td >
                                            <span className={paycl.pricein}>  {transaction.amount} $ </span>
                                
                                        </td>
                                        <td>
                                         
                                            {transaction.dealer_id > 0 ?

                                                (car?.vin || '')

                                            : 
                                                transaction.status_id === 1 ? 
                                                    "ჩარიცხული "
                                                : transaction.status_id === 2 ?
                                                    "უკან დაბრუნებული "  
                                                : transaction.status_id === 3 ?
                                                    "თანხის გადატანა "  
                                                :
                                                    '---' 
                                            }

                                            {transaction.is_deposit ? 
                                               "დეპოზიტი"
                                            : ""}

                                        {transaction.car_vin ?  <div>{transaction.car_vin} </div> : ''}

                                        </td>

                                        <td className={paycl.btntbl}>
                                        { isDeletePerm &&
                                            <div className={paycl.btns}>
                                                <div>
                                                    <span className={paycl.removeBtn} onClick={() => onRemove(transaction.id)} ><Remove /> წაშლა</span>
                                                </div>
                                            </div>
                                       }
                                        </td>

                                    </tr>
                                )}
                            </tbody>
                        </table>



                    </div>





                   { isAddPerm &&

                   
                    <div className={paycl.formField}>

                        <legend>გადახდის დამატება</legend>

                        <div className={paycl.row}>

                            {/*
                            <div style={{ width: '100%' }}>
                                <input type="text" className={paycl.input} name="description" placeholder='აღწერა' value={newTransaction.description} onChange={handleChange} />
                            </div>
                             */}


                            <div style={{ width: '100%' }}>
                            
                                <DateSelect
                                    defDate={new Date().toISOString()}
                                    onChange={handleDateChange}
                                    placeholderText="აირჩიე თარიღი"
                                    popperClassName={paycl.dataContainer}
                                    wrapperClassName={paycl.dataContainer}
                                    dataContainer={paycl.dataContainer }
                                    // isDisabled={!app.hasPermission("აქ უნდა შეიქმნას პრემისიონი")}
                                    className={validates && validates.created_at ? paycl.input+' '+ paycl.errorInput : paycl.input }
                                /> 

                            </div>
 
                            <div style={{ width: '100%' }}>

                                <Select
                                    styles={selectStyle}
                                    options={statusOptions}
                                    value={selectedOptionObject}
                                    onChange={handleChangeStatus}
                                    placeholder="სტატუსი"
                                />

                            </div>

                    
                        {selectedOption === 3 &&
                        
                            <div style={{ width: '100%' }}> 

                                {validates && validates.vin ? <div style={{ color: 'rgb(225, 29, 72)' }}>{validates.vin.message}</div>  : ""}

                                <Select
                                    styles={selectStyle}
                                    value={carsOptions.find((option) => option.value === inputValues[car.id])}
                                    onChange={(option) => handleChangeVin(option, car.id)}
                                    options={carsOptions}
                                    isClearable
                                    placeholder="აირჩიე ავტომობილი"
                                /> 
                                
                            </div>
                        }
                         
                        

                        <div style={{ width: '100%' }}>

                            <div className={paycl.uploadDiv}>
                                <input type="file" name="doc" onChange={e => setFile(e.target.files[0])} />
                            </div>
                        </div>
 
                            {validates && validates.amount ? <div style={{ color: 'rgb(225, 29, 72)' }}>{validates.amount.message}</div> : ""}


                            <div style={{ width: '140px' }}>
                                <div className={paycl.priceInput}>
                                    <div className={paycl.priceCurrency}>
                                        USD
                                    </div>
                                    <input type="text" onFocus={handleFocus} onBlur={handleBlur} className={paycl.input} name="amount" min="0" onChange={handleChangeAmount} value={newTransaction.amount} />
                                    <div className={paycl.hundred} >.00</div>
                                </div>
                            </div>


                        </div>

                        <div className={paycl.addBox}>
                            <span onClick={onAdd} className={paycl.addBtn}>გადახდა</span>
                        </div>

                    </div>
                     }


                </div>
            </Modal>
        </div>
    );
};

export default TransactionModal;